import { render, staticRenderFns } from "./InfoColumnItem.vue?vue&type=template&id=97deccea&"
import script from "./InfoColumnItem.vue?vue&type=script&lang=ts&"
export * from "./InfoColumnItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports